/**
 * Ежедневная награда и серия входов: календарь на 7 дней.
 */
import type { GameState } from '../../core/types';
import { DAILY_CYCLE, claimDaily, dailyReward, dailyStatus } from '../../core/daily';
import { eventMult } from '../../core/season';
import { t } from '../../i18n';
import { h, clearChildren } from '../dom';
import { openPanel } from '../modal';
import { packLines } from './packs';

export interface DailyCtx {
  state: GameState;
  now: () => number;
  petName: (defId: string) => string;
  /** вызывается после получения награды: сохранить, озвучить, показать сообщение */
  onClaimed: (day: number) => void;
}

export function openDaily(ctx: DailyCtx): void {
  let box: HTMLElement | null = null;

  const render = (): void => {
    if (!box) return;
    clearChildren(box);
    const st = dailyStatus(ctx.state, ctx.now());
    const mult = eventMult('daily');
    box.append(h('div', { class: 'daily-head' },
      h('div', { class: 'daily-streak' }, `🔥 ${t('daily.streak', { n: st.streak })}`),
      mult > 1 ? h('div', { class: 'daily-x2' }, t('daily.x2')) : null,
    ));

    const grid = h('div', { class: 'daily-grid' });
    for (let d = 1; d <= DAILY_CYCLE; d++) {
      const done = st.canClaim ? d < st.day : d <= st.day;
      const today = st.canClaim && d === st.day;
      const lines = packLines(dailyReward(ctx.state, d, mult));
      grid.append(h('div', { class: `daily-cell ${done ? 'done' : ''} ${today ? 'today' : ''} ${d === DAILY_CYCLE ? 'big' : ''}` },
        h('div', { class: 'daily-day' }, done ? `✅ ${t('daily.day', { n: d })}` : t('daily.day', { n: d })),
        h('ul', { class: 'daily-lines' }, ...lines.map((l) => h('li', {}, l))),
      ));
    }
    box.append(grid);

    box.append(h('button', {
      class: 'btn btn-primary daily-claim',
      ...(st.canClaim ? {} : { disabled: 'true' }),
      onclick: () => {
        const r = claimDaily(ctx.state, ctx.now(), ctx.petName);
        if (r.ok) ctx.onClaimed(r.day);
        render();
      },
    }, st.canClaim ? `🎁 ${t('daily.claim')}` : t('daily.claimed')));
    box.append(h('div', { class: 'daily-note' }, st.canClaim ? t('daily.reset') : t('daily.come')));
  };

  openPanel({
    title: `🎁 ${t('daily.title')}`,
    className: 'panel-wide',
    body: (container) => { box = container; render(); },
  });
}
